export const HOVER_OPEN_DELAY_MS = 80;
export const HOVER_CLOSE_DELAY_MS = 220;
export const HOVER_INTENT_SENSITIVITY_PX = 6;
export const HOVER_AIM_DELAY_MS = 300;
const HOVER_AIM_TOLERANCE_PX = 75;
const HOVER_AIM_STALE_MS = HOVER_OPEN_DELAY_MS * 1.5;

type Point = { x: number; y: number };

const aimPoints: Point[] = [];
let lastAimAt = 0;

export function resetAim() {
  aimPoints.length = 0;
}

export function recordAim(event: PointerEvent) {
  aimPoints.push({ x: event.clientX, y: event.clientY });
  lastAimAt = performance.now();
  if (aimPoints.length > 3) {
    aimPoints.shift();
  }
}

export function isAimingAt(panel: Element | null) {
  if (!panel || aimPoints.length < 2 || performance.now() - lastAimAt > HOVER_AIM_STALE_MS) {
    return false;
  }
  const location = aimPoints[aimPoints.length - 1];
  const previous = aimPoints[0];
  const box = panel.getBoundingClientRect();
  if (location.x >= box.left || location.x <= previous.x) {
    return false;
  }
  const upper = { x: box.left, y: box.top - HOVER_AIM_TOLERANCE_PX };
  const lower = { x: box.left, y: box.bottom + HOVER_AIM_TOLERANCE_PX };
  const slope = (from: Point, to: Point) => (to.y - from.y) / (to.x - from.x);
  return slope(location, upper) < slope(previous, upper) && slope(location, lower) > slope(previous, lower);
}
